/* eslint-disable eqeqeq */
import React, { useState, useEffect, useMemo } from "react";
/*eslint-disable-next-line*/
import { shallowEqual, useSelector } from "react-redux";
import { Chip } from "@material-ui/core";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { Skeleton } from "@material-ui/lab";
import * as PropTypes from "prop-types";
import moment from "moment";
import { isValid, parse, format } from "date-fns";
import { it } from "date-fns/locale"; // se vuoi i mesi in italiano

import {
  SortingState,
  IntegratedSorting,
  PagingState,
  IntegratedPaging,
  FilteringState,
  IntegratedFiltering,
  DataTypeProvider,
  RowDetailState,
} from "@devexpress/dx-react-grid";
import {
  Grid,
  Table,
  TableHeaderRow,
  PagingPanel,
  TableFilterRow,
  TableRowDetail,
} from "@devexpress/dx-react-grid-bootstrap4";
import "@devexpress/dx-react-grid-bootstrap4/dist/dx-react-grid-bootstrap4.css";
import SVG from "react-inlinesvg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxOpen, faSquareCheck } from "@fortawesome/free-solid-svg-icons";
/*eslint-disable-next-line*/
import { Card, Tooltip, OverlayTrigger, Button, Form, Table as BSTable } from "react-bootstrap";

import { roles, roleOptionsForSelect, icons, statusRichiestaServizio } from "../../config/config";
//import * as apiCampioni from "../../api/campioni";
import * as apiServizi from "../../api/servizi";
import * as apiArticoliEvento from "../../api/articoliEvento";
import * as apiProdotti from "../../api/prodotti";
import * as apiCampioni from "../../api/campioni";
import * as apiMateriale from "../../api/materiali";
import ArticoloEventoPicker from "./components/ArticoloEventoPicker";
import { isArticoloEventoOwner } from "./articoliEventoOwnership";

// Useful sub-components
const TableComponent = ({ ...restProps }) => (
  <Table.Table {...restProps} className="table table-hover table-head-custom table-vertical-center overflow-hidden" />
);

const getTableRow = (clickCallback) => {
  return ({ row, ...restProps }) => (
    <Table.Row
      {...restProps}
      // eslint-disable-next-line no-alert
      onClick={() => clickCallback(restProps.tableRow.rowId)}
      style={{
        cursor: "pointer",
      }}
    />
  );
};

const FilterCell = (props) => {
  return <TableFilterRow.Cell {...props} />;
};
FilterCell.propTypes = {
  column: PropTypes.shape({ name: PropTypes.string }).isRequired,
};

const DateFormattedColumn = (props) => (
  <DataTypeProvider formatterComponent={({ value }) => value.format("DD MMMM YYYY, HH:mm")} {...props} />
);

const makeActionBtn = ({ name, disabled, tooltip, callback, variant, icon, value }) => {
  const btn = (
    <Button
      variant={variant}
      className="mx-3 my-2 d-inline-flex align-items-center flex-nowrap"
      onClick={!disabled ? () => callback(value) : null}
      disabled={disabled}
      title={name}
    >
      {typeof icon == "string" ? (
        <span className={`svg-icon svg-icon-md svg-icon-white`}>
          {" "}
          <SVG src={toAbsoluteUrl(icon)} />
        </span>
      ) : (
        <FontAwesomeIcon icon={icon} className={`svg-icon-white`} style={{ marginRight: "0.5rem" }} />
      )}
      <span className="text-white">{name}</span>
      {/* {name} */}
    </Button>
  );
  if (!tooltip) return btn;
  return <OverlayTrigger overlay={<Tooltip>{tooltip}</Tooltip>}>{btn}</OverlayTrigger>;
};

const StatoColumn = ({ value }) => {
  /*eslint-disable-next-line*/
  if (value == statusRichiestaServizio.inAttesa)
    return (
      // in attesa
      <div className="pl-3">
        <Chip
          color="info"
          variant="outlined"
          label="In attesa"
          icon={<FontAwesomeIcon icon={faBoxOpen} className="svg-icon-info svg-icon-md" />}
          style={{ borderColor: "var(--info)" }}
        />
      </div>
    );
  if (value === statusRichiestaServizio.approvato)
    return (
      // consegnato
      <div className="pl-3">
        <Chip
          color=""
          variant="outlined"
          label="Approvato"
          icon={<FontAwesomeIcon icon={faSquareCheck} className="svg-icon-primary svg-icon-md" />}
          style={{ borderColor: "var(--primary)" }}
        />
      </div>
    );
  /*eslint-disable-next-line*/
  if (value == statusRichiestaServizio.annullato)
    return (
      // cancellato
      <div className="pl-3">
        <Chip
          color="danger"
          variant="outlined"
          label="Rifiutato"
          icon={
            <span className="svg-icon svg-icon-md svg-icon-danger">
              {" "}
              <SVG src={toAbsoluteUrl(icons.close)} />
            </span>
          }
          style={{ borderColor: "var(--danger)" }}
        />
      </div>
    );
  return <div className="pl-3"></div>;
};

export const StatoFormattedColumn = (props) => <DataTypeProvider formatterComponent={StatoColumn} {...props} />;

const CostoWithFallbackFormattedColumn = (props) => (
  <DataTypeProvider
    formatterComponent={({ value, row }) => {
      if (value !== undefined) {
        return `${value}€`;
      }
      if (row["stimaCosto"] !== undefined) {
        return `(${row["stimaCosto"]}€)`;
      }
      return "-";
    }}
    {...props}
  />
);

export const RichiestaRowDetailContext = React.createContext(null);

export const RichiestaRowDetailContent = ({ row }) => {
  const user = useSelector((state) => state.auth.user, shallowEqual);
  const {
    isRowLoading,
    costoIsEditing,
    costoEditedValue,
    noteIsEditing,
    noteEditedValue,
    noteSaving,
    noteError,
    canApprove,
    isAdmin,
    isDeveloper,
    updateCallback,
    updateEditedCostoCallback,
    cancelEditingCallback,
    startEditNoteCallback,
    updateEditedNoteCallback,
    cancelEditingNoteCallback,
    saveNoteCallback,
  } = React.useContext(RichiestaRowDetailContext);

  const [articoliRows, setArticoliRows] = useState([]);
  const [catalogo, setCatalogo] = useState([]);
  const [articoloNew, setArticoloNew] = useState({ sku: "", tipoArticolo: "", nomeArticolo: "", quantita: 1, lotto: "", data_scadenza: "", note: "" });
  const role = parseInt(user && user.idRole);
  const accessToken = user && user.authToken;
  const canManageArticoli = role === roles.admin || role === roles.gestore || role === roles.developer;
  const isStandApproved = row.type === "Stand" && row.status === statusRichiestaServizio.approvato;
  const isOwner = isArticoloEventoOwner(row, user);
  const showArticoliSection = isStandApproved && (canManageArticoli || isOwner);

  useEffect(() => {
    if (showArticoliSection && accessToken && row.idRichiesta) {
      apiArticoliEvento.getArticoliEventoByRichiesta(accessToken, row.idRichiesta)
        .then((res) => {
          const items = Array.isArray(res) ? res : (res && Array.isArray(res.data) ? res.data : []);
          setArticoliRows(items);
        })
        .catch(() => setArticoliRows([]));
    }
  }, [showArticoliSection, accessToken, row.idRichiesta]);

  useEffect(() => {
    if (showArticoliSection && canManageArticoli && accessToken) {
      const load = async () => {
        const results = await Promise.all([
          apiProdotti.getAll(accessToken).catch(() => null),
          apiCampioni.getAll(accessToken).catch(() => null),
          apiMateriale.getAll(accessToken).catch(() => null),
        ]);
        const [prodottiRes, campioniRes, materialeRes] = results;
        const toArr = (d) => {
          if (!d) return [];
          if (Array.isArray(d)) return d;
          if (d.data && Array.isArray(d.data)) return d.data;
          return [];
        };
        const list = [];
        toArr(prodottiRes).forEach((p) => list.push({ sku: p.sku, nomeArticolo: p.name || p.description || p.sku, tipoArticolo: "merce", image: p.image, qta: p.qta, division: p.division }));
        toArr(campioniRes).forEach((c) => list.push({ sku: c.sku, nomeArticolo: c.name || c.description || c.sku, tipoArticolo: "campione", image: c.image, qta: c.qta, division: c.division }));
        toArr(materialeRes).forEach((m) => list.push({ sku: m.sku, nomeArticolo: m.name || m.description || m.sku, tipoArticolo: "materiale_pubblicitario", image: m.image, qta: m.qta, division: m.division }));
        const uniq = {};
        list.forEach((l) => { uniq[l.sku + "|" + l.tipoArticolo] = l; });
        setCatalogo(Object.values(uniq));
      };
      load().catch(() => {});
    }
  }, [showArticoliSection, canManageArticoli, accessToken]);
      const isDisabled = {
        cancel:
          (!canApprove && row.status != statusRichiestaServizio.inAttesa) ||
          (canApprove && row.status == statusRichiestaServizio.annullato),
        approve: row.status == statusRichiestaServizio.approvato,
      };

      const hasMedico = !!row.medicoName;
      const hasStimaCosto = !!row.stimaCosto;
      const onEditSubmit = () =>
        updateCallback(row.idRichiesta, undefined, costoEditedValue(row.idRichiesta)).then(() =>
          cancelEditingCallback(row.idRichiesta)
        );
      return (
        <>
          <div className="card">
            <div className="p-8">
              <div className="d-flex align-items-center justify-content-xl-between mb-4">
                <span className="font-weight-bold text-muted font-size-sm mr-2">Tipo di richiesta</span>
                <span className="font-weight-bolder text-dark-50 text-xl-right">
                  <h5>{row.type}</h5>
                </span>
              </div>
              {/* Titolo Evento */}
              {row.titoloEvento && (
                <div className="d-flex align-items-center justify-content-xl-between mb-4">
                  <span className="font-weight-bold text-muted font-size-sm mr-2">Titolo Evento</span>
                  <span className="font-weight-bolder text-warning text-xl-right">
                    {row.titoloEvento
                      .split("\n")
                      .reduce((arr, line) => [...arr, line, <br />], [])
                      .slice(0, -1)}
                  </span>
                </div>
              )}

              {/* Data Evento */}
              {isValid(parse(row.dataInizio, "yyyy-MM-dd", new Date())) &&
                isValid(parse(row.dataFine, "yyyy-MM-dd", new Date())) && (
                  <div className="d-flex align-items-center justify-content-xl-between mb-4">
                    <span className="font-weight-bold text-muted font-size-sm mr-2">Data Evento</span>
                    <span className="font-weight-normal text-dark-50 text-xl-right">
                      dal{" "}
                      <span className="font-weight-bolder text-success">
                        {format(parse(row.dataInizio, "yyyy-MM-dd", new Date()), "d MMMM yyyy", { locale: it })}
                      </span>{" "}
                      al{" "}
                      <span className="font-weight-bolder text-danger">
                        {format(parse(row.dataFine, "yyyy-MM-dd", new Date()), "d MMMM yyyy", { locale: it })}
                      </span>
                    </span>
                  </div>
                )}
              {/* Sede */}
              {row.sede && (
                <div className="d-flex align-items-center justify-content-xl-between mb-4">
                  <span className="font-weight-bold text-muted font-size-sm mr-2">Sede</span>
                  <span className="font-weight-bolder text-dark-50 text-xl-right">{row.sede}</span>
                </div>
              )}
              {/* Segreteria */}
              {row.segreteria && (
                <div className="d-flex align-items-center justify-content-xl-between mb-4">
                  <span className="font-weight-bold text-muted font-size-sm mr-2">Segreteria</span>
                  <span className="font-weight-bolder text-dark-50 text-xl-right">{row.segreteria}</span>
                </div>
              )}
              {/* Medico */}
              {hasMedico && (
                //  Contenitore arrotondato
                // Intestazione della tabella
                
                <>
                <h5 className="font-weight-bold text-dark-100 font-size-sm mr-2">Dettagli Medico</h5>
                  <div className="bg-light rounded p-4">
                    <div className="d-flex align-items-center justify-content-xl-between mb-4">
                      <span className="font-weight-bold text-muted font-size-sm mr-2">Nome e Cognome</span>
                      <span className="font-weight-bolder text-dark-50 text-xl-right">{row.medicoFullname}</span>
                    </div>
                    <div className="d-flex align-items-center justify-content-xl-between mb-4">
                      <span className="font-weight-bold text-muted font-size-sm mr-2">Specializzazione</span>
                      <span className="font-weight-bolder text-dark-50 text-xl-right">
                        {row.medicoSpecializzazione}
                      </span>
                    </div>
                    <div className="d-flex align-items-center justify-content-xl-between mb-4">
                      <span className="font-weight-bold text-muted font-size-sm mr-2">Mail</span>
                      <span className="font-weight-bolder text-dark-50 text-xl-right">{row.medicoMail}</span>
                    </div>
                    <div className="d-flex align-items-center justify-content-xl-between mb-4">
                      <span className="font-weight-bold text-muted font-size-sm mr-2">Telefono</span>
                      <span className="font-weight-bolder text-dark-50 text-xl-right">{row.medicoPhone}</span>
                    </div>
                    <div className="d-flex align-items-center justify-content-xl-between mb-4">
                      <span className="font-weight-bold text-muted font-size-sm mr-2">Indirizzo</span>
                      <span className="font-weight-bolder text-dark-50 text-xl-right">{row.medicoAddress}</span>
                    </div>
                  </div>
                </>
              )}
              <div className="d-flex align-items-center justify-content-xl-between mb-4">
                <span className="font-weight-bold text-muted font-size-sm mr-2">Dati Eggiuntivi</span>
                <span className="font-weight-bolder text-dark-50 text-xl-right">
                  {row.description
                    .split("\n")
                    .reduce((arr, line) => [...arr, line, <br />], [])
                    .slice(0, -1)}
                </span>
              </div>
              <div className="mb-4">
                <h5 className="font-weight-bold text-dark-100 font-size-sm mr-2">Note dell'operatore</h5>
                <div className="bg-light rounded p-4">
                  {canApprove && noteIsEditing(row.idRichiesta) ? (
                    <>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        maxLength={4000}
                        aria-label="Note dell'operatore"
                        value={noteEditedValue(row.idRichiesta)}
                        onChange={(e) => updateEditedNoteCallback(row.idRichiesta, e.target.value)}
                        disabled={isRowLoading(row.idRichiesta) || noteSaving(row.idRichiesta)}
                        autoFocus
                      />
                      {noteError(row.idRichiesta) ? (
                        <div className="text-danger font-size-sm mt-2" role="alert">
                          {noteError(row.idRichiesta)}
                        </div>
                      ) : null}
                      <div className="d-flex align-items-center justify-content-end mt-3">
                        {noteSaving(row.idRichiesta) ? (
                          <span className="text-muted font-size-sm mr-3" role="status">
                            Salvataggio...
                          </span>
                        ) : null}
                        <Button
                          type="button"
                          variant="success"
                          className="btn-xs btn-icon ml-2"
                          aria-label="Salva nota dell'operatore"
                          disabled={isRowLoading(row.idRichiesta) || noteSaving(row.idRichiesta)}
                          onClick={() => saveNoteCallback(row.idRichiesta, noteEditedValue(row.idRichiesta))}
                        >
                          <i className="ki ki-check icon-xs"></i>
                        </Button>
                        <Button
                          type="button"
                          variant="light-danger"
                          className="btn-xs btn-icon ml-2"
                          aria-label="Annulla modifica nota dell'operatore"
                          disabled={isRowLoading(row.idRichiesta) || noteSaving(row.idRichiesta)}
                          onClick={() => cancelEditingNoteCallback(row.idRichiesta)}
                        >
                          <i className="ki ki-close icon-xs"></i>
                        </Button>
                      </div>
                    </>
                  ) : (
                    <div className="d-flex align-items-start justify-content-between">
                      <div className="text-dark-50 flex-grow-1">
                        {row.noteOperatore ? (
                          row.noteOperatore
                            .split("\n")
                            .reduce(
                              (arr, line, index) => [...arr, line, <br key={`${row.idRichiesta}-note-${index}`} />],
                              []
                            )
                            .slice(0, -1)
                        ) : (
                          <span className="text-muted font-italic">Nessuna nota</span>
                        )}
                      </div>
                      {canApprove ? (
                        <Button
                          type="button"
                          variant="light-success"
                          className="btn-xs btn-icon ml-2 flex-shrink-0"
                          aria-label="Modifica nota dell'operatore"
                          disabled={isRowLoading(row.idRichiesta) || noteSaving(row.idRichiesta)}
                          onClick={() => startEditNoteCallback(row.idRichiesta, row.noteOperatore)}
                        >
                          <span className={`svg-icon svg-icon-xs`}>
                            {" "}
                            <SVG src={toAbsoluteUrl(icons.edit)} />
                          </span>
                        </Button>
                      ) : null}
                    </div>
                  )}
                </div>
              </div>
              {hasStimaCosto ? (
                <div className="d-flex align-items-center justify-content-xl-between mb-4">
                  <span className="font-weight-bold text-muted font-size-sm mr-2">Stima costo dall'agente</span>
                  <div className="d-flex align-items-center">
                    <span className="font-weight-bolder text-dark-50 text-xl-right">{row.stimaCosto}€</span>
                  </div>
                </div>
              ) : null}
              <div className="d-flex align-items-center justify-content-xl-between mb-4">
                <span className="font-weight-bold text-muted font-size-sm mr-2">Costo</span>
                <div className="d-flex align-items-center">
                  {canApprove && costoIsEditing(row.idRichiesta) ? (
                    <>
                      <Form onSubmit={onEditSubmit}>
                        <Form.Control
                          type="text"
                          name="costo"
                          placeholder="€"
                          value={costoEditedValue(row.idRichiesta)}
                          onInput={(e) => {
                            // checks if a string is a positive number or empty
                            let val = e.target.value.replace(",", ".").replace(/[^0-9.]/g, "");
                            const shouldWait = val.endsWith(".");
                            if (shouldWait && val.search(/\.(.*)(\.)/) >= 0) {
                              val = val.substr(0, val.length - 1);
                            }
                            const parsed = shouldWait ? NaN : parseFloat(val);
                            if (!isNaN(parsed) && parsed >= 0) {
                              updateEditedCostoCallback(row.idRichiesta, Math.round(parsed * 100) / 100);
                            } else {
                              updateEditedCostoCallback(row.idRichiesta, val);
                            }
                          }}
                          autoFocus
                        />
                      </Form>
                      €
                    </>
                  ) : (
                    <>
                      <span className="font-weight-bolder text-dark-50 text-xl-right">
                        {row.costo === undefined ? "-" : row.costo}€
                      </span>
                      {canApprove ? (
                        <Button
                          variant="light-success"
                          className="btn-xs btn-icon ml-2"
                          disabled={isRowLoading(row.idRichiesta)}
                          onClick={() => updateEditedCostoCallback(row.idRichiesta, row.costo)}
                        >
                          <span className={`svg-icon svg-icon-xs`}>
                            {" "}
                            <SVG src={toAbsoluteUrl(icons.edit)} />
                          </span>
                        </Button>
                      ) : null}
                    </>
                  )}
                  {canApprove && costoIsEditing(row.idRichiesta) ? (
                    <Button
                      variant="success"
                      className="btn-xs btn-icon ml-2"
                      disabled={isRowLoading(row.idRichiesta)}
                      onClick={onEditSubmit}
                    >
                      <i className="ki ki-check icon-xs"></i>
                    </Button>
                  ) : null}
                  {canApprove && costoIsEditing(row.idRichiesta) ? (
                    <Button
                      variant="light-danger"
                      className="btn-xs btn-icon ml-2"
                      disabled={isRowLoading(row.idRichiesta)}
                      onClick={() => cancelEditingCallback(row.idRichiesta)}
                    >
                      <i className="ki ki-close icon-xs"></i>
                    </Button>
                  ) : null}
                </div>
              </div>

              {showArticoliSection && (
  <div className="mb-4">
    <h5 className="font-weight-bold text-dark-100 font-size-lg mb-4 border-bottom pb-2">
      Articoli Evento
    </h5>
    
    {/* Lista Articoli Esistenti */}
    <div className="mb-4">
      {articoliRows.length > 0 ? (
        <div className="row">
          {articoliRows.map((item) => {
            // Gestione immagine: usa l'URL fornito o un placeholder            
            
            let imageUrl = catalogo.find((c) => c.sku === item.sku)?.image;
            imageUrl = imageUrl!=null ? (imageUrl.startsWith('http') ? imageUrl : toAbsoluteUrl(imageUrl)) : null;
            console.log("Image:", imageUrl);
            return (
              <div key={item.id} className="col-md-6 col-lg-4 mb-3">
                <div className="card card-custom card-shadowless h-100 bg-light hover-elevate-up transition-all duration-150 overflow-hidden">
                  <div className="d-flex align-items-stretch h-100">
                    {/* Colonna Immagine */}
                    <div className="symbol symbol-75 rounded mr-1 ml-1 my-2 flex-shrink-0 bg-white align-content-center">
                      {imageUrl ? (
                        <img 
                          src={imageUrl} 
                          alt={item.nomeArticolo} 
                          className="object-fit-cover"
                          style={{ objectFit: 'cover' }}
                          onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }}
                        />
                      ) : null}
                      <div 
                        className="symbol-label bg-light-primary text-primary font-weight-bolder"
                        style={{ display: imageUrl ? 'none' : 'flex' }}
                      >
                        {item.nomeArticolo ? item.nomeArticolo.substring(0, 2).toUpperCase() : "NA"}
                      </div>
                    </div>

                    {/* Colonna Dettagli */}
                    <div className="card-body p-4 flex-grow-1 d-flex flex-column justify-content-between">
                      <div>
                        <div className="d-flex justify-content-between align-items-start mb-2">
                          <span className="label label-inline label-light-primary font-weight-bold mr-2">
                            {apiArticoliEvento.formatTipoArticolo(item.tipoArticolo)}
                          </span>
                          {canManageArticoli && (
                            <Button
                              variant="light-danger"
                              size="sm"
                              className="btn-icon btn-sm"
                              onClick={async () => {
                                if (window.confirm("Sei sicuro di voler eliminare questo articolo?")) {
                                  try {
                                    await apiArticoliEvento.deleteArticoloEvento(user.authToken, item.id);
                                    const res = await apiArticoliEvento.getArticoliEventoByRichiesta(user.authToken, row.idRichiesta);
                                    setArticoliRows(Array.isArray(res) ? res : (res?.data || []));
                                  } catch (e) {
                                    console.error(e);
                                  }
                                }
                              }}
                              title="Elimina articolo"
                            >
                              <i className="ki ki-close icon-xs"></i>
                            </Button>
                          )}
                        </div>
                        
                        <h6 className="font-weight-bold text-dark mb-1 text-truncate" title={item.nomeArticolo}>
                          {item.nomeArticolo}
                        </h6>
                        <p className="text-muted font-size-sm mb-3">SKU: {item.sku}</p>
                        
                        <div className="d-flex flex-column gap-2 font-size-sm">
                          <div className="d-flex justify-content-between">
                            <span className="text-muted">Quantità:</span>
                            <span className="font-weight-bold">{item.quantita}</span>
                          </div>
                          {item.lotto && (
                            <div className="d-flex justify-content-between">
                              <span className="text-muted">Lotto:</span>
                              <span className="font-weight-medium">{item.lotto}</span>
                            </div>
                          )}
                          {item.data_scadenza && (
                            <div className="d-flex justify-content-between">
                              <span className="text-muted">Scadenza:</span>
                              <span className={`font-weight-medium ${moment(item.data_scadenza).isBefore(moment(), 'month') ? 'text-danger' : 'text-success'}`}>
                                {apiArticoliEvento.formatMonthExpiry(item.data_scadenza)}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                      
                      {item.note && (
                        <div className="mt-3 pt-3 border-top">
                          <small className="text-muted font-italic text-truncate d-block" title={item.note}>
                            "{item.note}"
                          </small>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="text-center py-8 text-muted bg-light rounded">
          <i className="ki ki-box icon-3x mb-3"></i>
          <p>Nessun articolo assegnato a questa richiesta</p>
        </div>
      )}
    </div>

    {/* Form Aggiunta Nuovo Articolo (Solo Admin/Gestore/Developer) */}
    {canManageArticoli && (
      <div className="card card-custom bg-light border-dashed">
        <div className="card-header border-0 py-4">
          <h6 className="font-weight-bold text-dark m-0">Aggiungi Nuovo Articolo</h6>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-4 mb-3">
              <label className="font-weight-bold text-muted font-size-sm mb-2">Articolo</label>
              <ArticoloEventoPicker
                options={catalogo}
                value={catalogo.find((c) => c.sku === articoloNew.sku && c.tipoArticolo === articoloNew.tipoArticolo) || null}
                onChange={(article) =>
                  setArticoloNew({
                    ...articoloNew,
                    sku: article ? article.sku : "",
                    tipoArticolo: article ? article.tipoArticolo : "",
                    nomeArticolo: article ? article.nomeArticolo : "",
                  })
                }
              />
            </div>
            
            <div className="col-md-2 mb-3">
              <label className="font-weight-bold text-muted font-size-sm mb-2">Quantità</label>
              <Form.Control 
                type="number" 
                min="1" 
                value={articoloNew.quantita} 
                onChange={(e) => setArticoloNew({ ...articoloNew, quantita: parseInt(e.target.value) || 1 })} 
                placeholder="Qty" 
              />
            </div>
            
            <div className="col-md-3 mb-3">
              <label className="font-weight-bold text-muted font-size-sm mb-2">Lotto / Scadenza</label>
              <div className="input-group">
                <Form.Control 
                  value={articoloNew.lotto} 
                  onChange={(e) => setArticoloNew({ ...articoloNew, lotto: e.target.value })} 
                  placeholder="Lotto" 
                  className="border-right-0"
                />
                <Form.Control 
                  type="month" 
                  value={articoloNew.data_scadenza} 
                  onChange={(e) => setArticoloNew({ ...articoloNew, data_scadenza: e.target.value })} 
                  className="border-left-0"
                  placeholder="MM/YYYY"
                />
              </div>
            </div>
            
            <div className="col-md-3 mb-3">
              <label className="font-weight-bold text-muted font-size-sm mb-2">Note</label>
              <Form.Control 
                value={articoloNew.note} 
                onChange={(e) => setArticoloNew({ ...articoloNew, note: e.target.value })} 
                placeholder="Note aggiuntive" 
              />
            </div>
          </div>
          
          <div className="d-flex justify-content-end mt-2">
            <Button
              variant="primary"
              size="sm"
              disabled={!articoloNew.sku || !articoloNew.tipoArticolo}
              onClick={async () => {
                try {
                  await apiArticoliEvento.addArticoloEvento(user.authToken, {
                    idRichiesta: row.idRichiesta,
                    sku: articoloNew.sku,
                    tipoArticolo: articoloNew.tipoArticolo === "prodotto" ? "merce" : (articoloNew.tipoArticolo === "materiale" ? "materiale_pubblicitario" : articoloNew.tipoArticolo),
                    nomeArticolo: articoloNew.nomeArticolo,
                    image: articoloNew.image,
                    lotto: articoloNew.lotto || null,
                    data_scadenza: articoloNew.data_scadenza || null,
                    quantita: articoloNew.quantita,
                    note: articoloNew.note || null,
                  });
                  const res = await apiArticoliEvento.getArticoliEventoByRichiesta(user.authToken, row.idRichiesta);
                  setArticoliRows(Array.isArray(res) ? res : (res?.data || []));
                  setArticoloNew({ sku: "", tipoArticolo: "", nomeArticolo: "", image: "", quantita: 1, lotto: "", data_scadenza: "", note: "" });
                } catch (e) {
                  console.error(e);
                }
              }}
            >
              <i className="ki ki-plus icon-xs mr-2"></i>
              Aggiungi Articolo
            </Button>
          </div>
        </div>
      </div>
    )}
  </div>
)}
            </div>
            <div className="separator separator-solid"></div>
            {isAdmin || isDeveloper ? (
              <>
                <div>
                  <div className="float-xl-right">
                    {makeActionBtn({
                      name: canApprove ? "Rifiuta" : "Annulla",
                      callback: (id) => updateCallback(id, statusRichiestaServizio.annullato, undefined),
                      disabled: isRowLoading(row.idRichiesta) || isDisabled.cancel,
                      variant: "danger",
                      icon: icons.close,
                      value: row.idRichiesta,
                    })}
                    {canApprove
                      ? makeActionBtn({
                          name: "Approva",
                          callback: (id) => updateCallback(id, statusRichiestaServizio.approvato, undefined),
                          disabled: isRowLoading(row.idRichiesta) || isDisabled.approve,
                          variant: "primary",
                          icon: faSquareCheck,
                          value: row.idRichiesta,
                        })
                      : null}
                  </div>
                </div>
              </>
            ) : null}
          </div>
        </>
      );
};

// Fields: idRichiesta, costo, description, status, dateCreated, dateUpdated, agenteName, agenteLastname, agenteFullname, medicoName, medicoLastname, medicoFullname, medicoMail, medicoPhone
// Columns definition
const serviziColumns = [
  { name: "agenteFullname", title: "Agente" },
  { name: "status", title: "Stato" }, // 0:In attesa, 1: Approvato, 2:Annullato/Rifiutato
  { name: "type", title: "Tipo" },
  { name: "dateUpdated", title: "Ultima Modifica" },
  { name: "medicoFullname", title: "Medico" },
  { name: "costo", title: "Stima costo" },
  { name: "dateCreated", title: "Data Creazione" },
];
const serviziColumnExtensions = [
  { columnName: "agenteFullname", wordWrapEnabled: true },
  { columnName: "status", width: "auto" },
  { columnName: "type", wordWrapEnabled: true },
  { columnName: "dateUpdated", wordWrapEnabled: true },
  { columnName: "medicoFullname", wordWrapEnabled: true },
  { columnName: "costo", wordWrapEnabled: true },
  { columnName: "dateCreated", wordWrapEnabled: true },
];

// Messages
const tableMessages = {
  noData: "Nessuna richiesta effettuata",
};
const filterRowMessages = {
  filterPlaceholder: "Filtra...",
};
const pagingPanelMessages = {
  showAll: "Tutte",
  rowsPerPage: "Righe per pagina",
  info: "Da {from} a {to} ({count} richieste)",
};

// Paging and sorting
const pageSizes = [10, 20, 30, 0];
const initialPageSize = 10;
const initialSorting = [{ columnName: "lastUpdate", direction: "desc" }];

export const RichiesteServizi = () => {
  // table data
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingRows, setLoadingRows] = useState({});
  const [costoEditingRows, setCostoEditingRows] = useState({});
  const [noteEditingRows, setNoteEditingRows] = useState({});
  const [noteSavingRows, setNoteSavingRows] = useState({});
  const [noteErrorRows, setNoteErrorRows] = useState({});
  const [_internalUpdateCount, _setInternalUpdateCount] = useState(0);

  // Stato dei filtri (dx-react-grid lavora con un array di oggetti: { columnName, value })
  const [filters, setFilters] = useState([]);

  // User redux
  const user = useSelector((state) => state.auth.user, shallowEqual);
  const role = parseInt(user.idRole);

  // nascondi colonna "agente" se non admin/magazziniere
  const columns =
    role === roles.admin || role === roles.gestore || role === roles.developer || role === roles.magazziniere || role === roles.contabile
      ? serviziColumns
      : serviziColumns.slice(1);

  const updateFromServer = async () => {
    setLoading(true);

    await apiServizi
      .getAll(user.authToken)
      .then((data) => {
        const sortedData = data.sort((a, b) => {
          return new Date(b.dateCreated) - new Date(a.dateCreated);
        });
        setRows(sortedData);
      })
      .then(() => setLoading(false));
  };

  useEffect(() => {
    updateFromServer();
    /*eslint-disable-next-line*/
  }, [_internalUpdateCount]);

  const doUpdate = () => {
    _setInternalUpdateCount(_internalUpdateCount + 1);
  };

  const addLoadingRow = (id) => {
    const clone = { ...loadingRows };
    clone[id] = true;
    setLoadingRows(clone);
  };
  const removeLoadingRow = (id) => {
    const clone = { ...loadingRows };
    delete clone[id];
    setLoadingRows(clone);
  };

  const addCostoEditingRow = (id, costo) => {
    const clone = { ...costoEditingRows };
    clone[id] = costo;
    setCostoEditingRows(clone);
  };
  const removeCostoEditingRow = (id) => {
    const clone = { ...costoEditingRows };
    delete clone[id];
    setCostoEditingRows(clone);
  };

  const startEditingNote = (id, noteOperatore) => {
    setNoteEditingRows((previous) => ({ ...previous, [id]: noteOperatore }));
    setNoteErrorRows((previous) => {
      const clone = { ...previous };
      delete clone[id];
      return clone;
    });
  };
  const updateEditedNote = (id, noteOperatore) => {
    setNoteEditingRows((previous) => ({ ...previous, [id]: noteOperatore }));
  };
  const cancelEditingNote = (id) => {
    setNoteEditingRows((previous) => {
      const clone = { ...previous };
      delete clone[id];
      return clone;
    });
    setNoteErrorRows((previous) => {
      const clone = { ...previous };
      delete clone[id];
      return clone;
    });
  };
  const saveNote = async (id, noteOperatore) => {
    setNoteSavingRows((previous) => ({ ...previous, [id]: true }));
    setNoteErrorRows((previous) => {
      const clone = { ...previous };
      delete clone[id];
      return clone;
    });
    try {
      await apiServizi.updateNote(user.authToken, id, noteOperatore);
      cancelEditingNote(id);
      doUpdate();
    } catch (error) {
      setNoteErrorRows((previous) => ({
        ...previous,
        [id]: error.plainMessage || error.message || "Errore nel salvataggio",
      }));
    } finally {
      setNoteSavingRows((previous) => {
        const clone = { ...previous };
        delete clone[id];
        return clone;
      });
    }
  };

  // paging and sorting
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(initialPageSize);
  const [sorting, setSorting] = useState(initialSorting);
  const [expandedRows, setExpandedRows] = useState([]);

  /*eslint-disable-next-line*/
  //const campioniMap = new Map(rows.map((c) => [c.id, c]));

  // Calcolo delle righe filtrate in base ai filtri attivi
  const filteredRows = useMemo(() => {
    if (filters.length === 0) return rows;
    return rows.filter((row) =>
      filters.every((f) => {
        const cellValue = row[f.columnName];
        return cellValue
          ?.toString()
          .toLowerCase()
          .includes(f.value.toLowerCase());
      })
    );
  }, [rows, filters]);

  // Totale dei costi calcolato sulle righe filtrate
  const totaleCostiFiltrato = useMemo(() => {
    return filteredRows.reduce((sum, row) => sum + Number(row.stimaCosto || 0), 0);
  }, [filteredRows]);

  const detailContextValue = {
    /*eslint-disable-next-line*/
    isRowLoading: (id) => id in loadingRows,
    canApprove: role === roles.admin || role === roles.gestore || role === roles.developer || role === roles.contabile,
    isAdmin: role === roles.admin || role === roles.gestore,
    isDeveloper: role === roles.developer,
    costoIsEditing: (id) => id in costoEditingRows,
    costoEditedValue: (id) => costoEditingRows[id],
    noteIsEditing: (id) => id in noteEditingRows,
    noteEditedValue: (id) => noteEditingRows[id],
    noteSaving: (id) => id in noteSavingRows,
    noteError: (id) => noteErrorRows[id],
    updateCallback: (id, nuovoStatus, nuovoCosto) => {
      addLoadingRow(id);
      return apiServizi.update(user.authToken, id, nuovoStatus, nuovoCosto).then(() => {
        removeLoadingRow(id);
        doUpdate();
      });
    },
    updateEditedCostoCallback: addCostoEditingRow,
    cancelEditingCallback: removeCostoEditingRow,
    startEditNoteCallback: startEditingNote,
    updateEditedNoteCallback: updateEditedNote,
    cancelEditingNoteCallback: cancelEditingNote,
    saveNoteCallback: saveNote,
  };

  return (
    <>
      <Card className="card-custom gutter-b">
        <Card.Header className="border-0 py-5 row">
          <Card.Title className="float-left col-auto">
            <div>
              <h3 className="font-weight-bolder text-dark">Richieste di Servizi</h3>
              <h5>Totale stima Costi: {totaleCostiFiltrato} €</h5>
              <h6 className="font-weight-light text-dark mobile-only">
                Scorri a destra la tabella per altre informazioni
              </h6>
            </div>
          </Card.Title>
        </Card.Header>
        <Card.Body className="pt-0">
          <div className="mr-3 ml-3 alert alert-secondary text-right" role="alert">
            <strong>Legenda stati</strong> 0: In attesa, 1: Approvato, 2: Rifiutato
          </div>
          {!loading ? (
            <RichiestaRowDetailContext.Provider value={detailContextValue}>
            <Grid rows={[...rows.values()].map((row) => ({ ...row }))} columns={columns}>
              <DateFormattedColumn for={["dateCreated", "dateUpdated"]} />
              <StatoFormattedColumn for={["status"]} />
              <CostoWithFallbackFormattedColumn for={["costo"]} />
              {/* <ExtraFormattedColumn for={["extra"]} /> */}
              <RowDetailState expandedRowIds={expandedRows} onExpandedRowIdsChange={setExpandedRows} />

              {/* Passiamo lo stato dei filtri a FilteringState */}
              <FilteringState filters={filters} onFiltersChange={setFilters} />

              <IntegratedFiltering />
              <PagingState
                currentPage={currentPage}
                onCurrentPageChange={setCurrentPage}
                pageSize={pageSize}
                onPageSizeChange={setPageSize}
              />
              <IntegratedPaging />
              <SortingState sorting={sorting} onSortingChange={setSorting} />
              <IntegratedSorting />
              <Table
                messages={tableMessages}
                tableComponent={TableComponent}
                columnExtensions={serviziColumnExtensions}
                rowComponent={getTableRow((id) => {
                  if (expandedRows.includes(id)) cancelEditingNote(id);
                  setExpandedRows(
                    expandedRows.includes(id) ? [...expandedRows].filter((v) => v != id) : [...expandedRows, id]
                  );
                })}
              />
              <TableHeaderRow showSortingControls />
              <TableFilterRow messages={filterRowMessages} cellComponent={FilterCell} />
              <TableRowDetail contentComponent={RichiestaRowDetailContent} />

              <PagingPanel messages={pagingPanelMessages} pageSizes={pageSizes} />
            </Grid>
            </RichiestaRowDetailContext.Provider>
          ) : (
            <div>
              <Skeleton variant="text" />
              <Skeleton variant="text" />
              <Skeleton variant="text" />
              <Skeleton variant="rect" height={518} />
            </div>
          )}
        </Card.Body>
      </Card>
    </>
  );
};
